import React from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import { Link } from 'react-router';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';

const ViewResultsAction = ({
  assignmentId,
  subjectInfo,
  onClick,
  disabled,
}) => {
  const url = !subjectInfo.isPreApSubject
    ? `/${subjectInfo.id}/assessments/results/${assignmentId}`
    : `/${subjectInfo.id}/aggregate/results/${assignmentId}`;

  return (
    <AccessibilityWrapper>
      <Link
        to={{ pathname: url }}
        role="button"
        tabIndex={-1}
        aria-label="View Results"
        onClick={() => onClick()}
        className="inline-block"
        iconName="view_results"
        disabled={disabled}
      >
        <SingleAction iconName="view_results" disabled={disabled}>
          <span className="item-text">View Results</span>
        </SingleAction>
      </Link>
    </AccessibilityWrapper>
  );
};

export default ViewResultsAction;
